<script setup lang="ts">
import { RouterLink } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col bg-slate-50 text-slate-950">
    <AppHeader />
    <main class="flex-1">
      <slot />
    </main>
    <footer class="border-t border-slate-200 bg-white py-8 text-sm text-slate-500">
      <div class="mx-auto flex max-w-7xl flex-col gap-4 px-4 text-center sm:px-6 lg:px-8">
        <p>MoneyRelay is read-only financial data infrastructure for user-authorized personal agents.</p>
        <nav class="flex flex-wrap justify-center gap-x-5 gap-y-2" aria-label="Legal and support links">
          <RouterLink to="/privacy" class="hover:text-emerald-700">Privacy</RouterLink>
          <RouterLink to="/terms" class="hover:text-emerald-700">Terms</RouterLink>
          <RouterLink to="/security" class="hover:text-emerald-700">Security</RouterLink>
          <RouterLink to="/data-deletion" class="hover:text-emerald-700">Data deletion</RouterLink>
          <RouterLink to="/support" class="hover:text-emerald-700">Support</RouterLink>
          <a href="https://logo.dev" class="hover:text-emerald-700">Logos provided by Logo.dev</a>
        </nav>
        <p>Contact <a href="mailto:admin@moneyrelay.ai" class="font-semibold text-slate-700 hover:text-emerald-700">admin@moneyrelay.ai</a>.</p>
      </div>
    </footer>
  </div>
</template>
